export default __webpack_public_path__ + "292e71fc2c074334d62928ff73512544.svg";